<app-top-bar [toShowHelp]="isHelp" [toShowProdConfig]="isProdConfig" [toShowUnitConfig]="isUnitConfig"
    [toShowProfile]="isProfile" [isAlertNotificationIcon]="isAlert" [toShowCustomerName]="isName"></app-top-bar>
<div class="row denied-error-sec">
    <div class="col-md-12 col-lg-12 access-denied-sec">
        <span class="ban-icon">
            <i class="fa fa-ban" aria-hidden="true"></i>
        </span>
        <div class="msg-sec">
            <h1 class="main-txt">
                Access Denied !
            </h1>
            <h3 class="sub-txt">You dont have permission to view this page.</h3>
            <a href="#" class="btn btn-link"> Go back to home</a>
        </div>
    </div>

</div>
<div class="row">
    <div class="col-md-12 col-lg-12">
        <app-footer-mine-nxt></app-footer-mine-nxt>
    </div>
</div>